import React from "react";

import { formatNumber, useGetFarmAreaSummary } from "utils";

import { CarbonProgram } from "models";

import { AdminDescriptions, Col, ErrorBoundary, Row, SkeletonWrapper } from "components";

import { FarmPayout } from "pages/admin/carbonPrograms/components/FarmPayout.tsx";

export const FarmAreaSummary = ({ fieldIds, farmId, carbonProgram }: { fieldIds: string[]; farmId: string; carbonProgram?: CarbonProgram }) => {
  const { areaSummary, isLoading } = useGetFarmAreaSummary({ farmId });

  return (
    <>
      <SkeletonWrapper isLoading={isLoading}>
        <ErrorBoundary>
          <Row>
            <Col>
              <AdminDescriptions
                items={[
                  {
                    label: "Field continuation area",
                    span: 1,
                    children: areaSummary?.fieldContinuationArea ? `${formatNumber({ number: areaSummary.fieldContinuationArea })} ha` : "Unknown",
                  },
                  {
                    label: "Provided field continuation area",
                    span: 1,
                    children: areaSummary?.providedFieldContinuationArea
                      ? `${formatNumber({ number: areaSummary.providedFieldContinuationArea })} ha`
                      : "Unknown",
                  },
                  {
                    label: "Activable hectares",
                    span: 1,
                    children: areaSummary?.activatableHectares ? `${formatNumber({ number: areaSummary.activatableHectares })} ha` : "Unknown",
                  },
                  {
                    label: "Field payout",
                    span: 1,
                    children: (
                      <>
                        <FarmPayout fieldIds={fieldIds} farmId={farmId} carbonProgram={carbonProgram} />
                      </>
                    ),
                  },
                ]}
                columns={null}
              />
            </Col>
          </Row>
        </ErrorBoundary>
      </SkeletonWrapper>
    </>
  );
};
